// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__gjvWk","colCheckbox":"styles_colCheckbox__pF84J"};